<template>
  <action-dispatcher
    action="product/getProduct"
    :parameters="$route.params.id"
    class="view-member-area-categories"
  >
    <step-title
      title="Categorias"
      description="Crie categorias para organizar os módulos da sua área de membros"
    />
    <div v-if="!categories.length && loading" class="text-center">
      <b-spinner variant="primary" />
    </div>

    <div
      v-else-if="!categories.length"
      class="container centering text-center mt-9"
    >
      <img
        class="d-block mb-9 mx-auto"
        src="@/assets/images/home/welcome.svg"
      />
      <h5>Bem-vindo(a) a área de categorias do seu produto</h5>
      <div class="text-secondary mb-9">
        Para começar, cadastre a primeira categoria.
      </div>
      <button class="btn btn-primary" @click="() => openCategoryModal()">
        Cadastrar Categoria
      </button>
    </div>

    <template v-else>
      <div class="row justify-content-between mb-3">
        <div class="col-lg-4 mb-5 mb-lg-0">
          <div class="d-flex align-items-center">
            <div class="d-flex flex-column">
              <span class="table-quantity-counter mr-3">
                Total: {{ pagination.count }}
              </span>
            </div>
            <button class="btn p-0 table-refresh" @click="refresh">
              <i class="fa-solid fa-refresh" />
            </button>
          </div>
        </div>
        <div class="col-xl-5 col-lg-6">
          <div class="d-flex justify-content-between mb-3">
            <search-filter
              placeholder="Pesquisar"
              @search="searching"
              class="mb-3 mb-lg-0 flex-fill"
              filterButtonText=""
              :showResultsDropdown="false"
              :newDesign="true"
            >
            </search-filter>
            <button
              type="button"
              class="btn-sm btn-primary ml-3 btn-40 p-0"
              @click="() => openCategoryModal()"
            >
              <div
                class="d-flex flex-row justify-content-between align-items-center px-3"
              >
                <i class="fa fa-plus pr-5" />
                <span>Nova Categoria</span>
              </div>
            </button>
          </div>
        </div>
      </div>

      <div v-if="loading" class="text-center">
        <b-spinner variant="primary" />
      </div>

      <draggable-categories
        v-else
        v-model="sortedCategories"
        :handle="!search"
        @edit-category="editCategory"
        @remove-category="removeCategory"
        @change-status="changeStatus"
      />
    </template>
    <responsive-modal v-model="dialog.category" size="lg">
      <category-modal
        :category="editedItem"
        @close="dialog.category = false"
        @success="categoryOnSuccess"
        class="p-5"
      />
    </responsive-modal>
  </action-dispatcher>
</template>

<script>
import DraggableCategories from "@/components/product/details/content/DraggableCategories";
import ProductActionsMixin from "@/mixins/productActions.js";
import { mapState } from "vuex";
import CategoryModal from "../../components/product/details/content/category/CategoryModal.vue";

export default {
  mixins: [ProductActionsMixin],
  components: {
    DraggableCategories,
    CategoryModal
  },
  data() {
    return {
      params: {
        product_id: this.$route.params.id
      },
      loading: false,
      search: "",
      editedIndex: null,
      editedItem: null,
      dialog: {
        category: false
      }
    };
  },
  computed: {
    ...mapState("product", ["product"]),
    ...mapState("membersCategories", ["categories", "pagination"]),
    breadcrumbs() {
      return [
        { link: "product", title: "Meus produtos" },
        {
          link: "product-details",
          title: this.product ? this.product["name"] : "...",
          params: { id: this.$route.params.id }
        },
        {
          title: "Categorias"
        }
      ];
    },
    filteredItems() {
      return this.sortedCategories.filter(category =>
        category.name.toLowerCase().includes(this.search.toLowerCase())
      );
    },
    sortedCategories: {
      get() {
        return [...this.categories]
          .filter(category =>
            category.name.toLowerCase().includes(this.search.toLowerCase())
          )
          .sort((a, b) => a.sort - b.sort);
      },
      set(val) {
        for (let i in val) {
          val[i].sort = i;
        }
        this.$store.commit("membersCategories/setCategories", val);
        this.saveOrder();
      }
    }
  },
  mounted() {
    this.dispatch();
  },
  methods: {
    openCategoryModal(item = {}) {
      this.editedItem = item;
      this.dialog.category = true;
    },
    categoryOnSuccess() {
      this.dialog.category = false;
      this.refresh();
    },
    saveOrder() {
      this.$store.dispatch(
        "membersCategories/reorder",
        this.categories.reduce((prev, curr) => [...prev, curr], [])
      );
    },
    editCategory(category) {
      this.editedItem = category;
      this.dialog.category = true;
    },
    removeCategory(category) {
      this.$store
        .dispatch("membersCategories/delete", category.id)
        .then(this.refresh);
    },
    changeStatus(category) {
      this.loading = true;
      this.$store
        .dispatch("membersCategories/changeStatus", category)
        .then(this.refresh);
    },
    searching(v) {
      this.search = v;
    },
    refresh() {
      this.dispatch();
    },
    dispatch() {
      this.loading = true;
      this.$store
        .dispatch("membersCategories/getAll", this.params)
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.view-member-area-categories {
  a {
    text-decoration: none;
  }
  .box {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border: 1px solid #d2d0d8;
    border-radius: 4px;
    height: 232px;
    cursor: pointer;
    img {
      height: 54px;
      width: 54px;
    }

    &:hover {
      background: linear-gradient(148.5deg, #ee6469 -19.31%, #5576ec 100%);
      border-color: rgb(191, 92, 170);

      strong {
        color: white;
      }
    }
  }

  .handle {
    cursor: grab;
  }

  .btn {
    white-space: nowrap;
  }
}
</style>
